import type { FeatureFlag } from '@/types'

// Values must match the keys in the `FEATURE_FLAGS` section of the file from VITE_CUSTOM_LANG_URL (swr.json).
export const FEATURE_FLAG = {
  // Final campaign phase: shows a static mobilization message instead of the waiting families counter.
  IS_MOBILIZATION_PHASE: 'isMobilizationPhase'
} as const

// Defaults used when the flag is missing in swr.json.
export const FEATURE_FLAGS_DEFAULTS = {
  [FEATURE_FLAG.IS_MOBILIZATION_PHASE]: false
} as const satisfies Record<FeatureFlag, boolean>
